import React from "react";
import cityImage from "../../assets/images/city-auth.png";

export default function AuthImageSide() {
  return (
    <div
      className="authside__banner"
      style={{ backgroundImage: `url(${cityImage})` }}
    ></div>
  );
}
